// extracted by mini-css-extract-plugin
export default {"Container":"Footer_Container__A6d6F","rotate":"Footer_rotate__Xc+Fo","text":"Footer_text__x57if","line":"Footer_line__fgjC7","header__content":"Footer_header__content__ASCB8"};